import React from 'react'
import { useTranslation } from 'translations'
import { Section } from '../components/section'
import { Permission } from 'settings/schema'
import { PermissionToggle } from '../components/permissionToggle'

interface GeneralPermissionsSectionProps {
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
}

export const GeneralPermissionsSection = ({
    isAdminGranted,
    handlePermissionClick,
}: GeneralPermissionsSectionProps) => {
    const { t } = useTranslation()

    return (
        <Section title={t('settings.users.form.sections.general')} className="general-permissions">
            <div className="row">
                <PermissionToggle
                    permission="access_analytics"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
            </div>
            <div className="row">
                <PermissionToggle
                    permission="access_codes"
                    handleClick={handlePermissionClick}
                    disabled={isAdminGranted}
                />
            </div>
        </Section>
    )
}
